var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.84 6.657l-.045.044.045.045 5.183 5.183a.562.562 0 01-.796.795L7.044 7.541 7 7.497l-.044.044-5.183 5.183h0a.562.562 0 11-.796-.795h0L6.16 6.746l.045-.045-.045-.044L.977 1.474A.562.562 0 011.773.68l5.183 5.183.044.044.044-.044L12.227.679a.562.562 0 01.796.795L7.84 6.657z","fill":"#fff","stroke":"#fff","strokeWidth":".125"}));
}

Close.defaultProps = {"width":"14","height":"13","viewBox":"0 0 14 13","fill":"none"};

module.exports = Close;

Close.default = Close;
